<template>
  <v-list-item v-on:click="clicked" link>
    <v-list-item-icon v-if="icon">
      <v-icon color="blue">{{ icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title :class="titleClass" v-if="title">{{ title }}</v-list-item-title>
      <v-list-item-subtitle v-if="subtitle" class="mb-2">
        {{ subtitle }}
        <slot name="subtitle"></slot>
      </v-list-item-subtitle>
      <slot></slot>
    </v-list-item-content>

    <v-list-item-icon v-if="iconAction">
      <v-icon color="primary">{{ iconAction }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: "LocationInfoItem",
  props: {
    icon: String,
    iconAction: String,
    title: String,
    subtitle: String,
    titleClass: String
  },
  methods: {
    clicked: function(event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>

</style>